var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "lg",
        "confirm-loading": _vm.loading,
        "confirm-text": "Lưu nhận xét",
        "cancel-text": "Đóng",
        "use-panel": true,
        "panel-title": _vm.panelTitle,
        "panel-subtitle": `Nhập cùng nội dung cho nhiều học sinh`,
        "panel-icon":
          _vm.period === "WEEKLY" ? "el-icon-document" : "el-icon-notebook-2",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleSave,
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-u-mt-12",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c("div", { staticClass: "selected-students-card" }, [
            _c("div", { staticClass: "selected-students-card__header" }, [
              _c(
                "div",
                { staticClass: "selected-students-card__title" },
                [
                  _c("i", { staticClass: "el-icon-user" }),
                  _vm._v(" Danh sách học sinh nhận xét\n          "),
                  _c(
                    "el-tag",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        size: "mini",
                        type:
                          _vm.dataForm.students.length > 0
                            ? "primary"
                            : "danger",
                      },
                    },
                    [
                      _vm._v(
                        "\n            Đã chọn: " +
                          _vm._s(_vm.dataForm.students.length) +
                          " / " +
                          _vm._s(_vm.allStudents.length) +
                          " học sinh\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "selected-students-card__actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "text",
                        icon: "el-icon-check",
                      },
                      on: { click: _vm.selectAllStudents },
                    },
                    [_vm._v("\n            Chọn tất cả\n          ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "text-danger",
                      attrs: {
                        size: "mini",
                        type: "text",
                        icon: "el-icon-close",
                      },
                      on: { click: _vm.deselectAllStudents },
                    },
                    [_vm._v("\n            Bỏ chọn hết\n          ")]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "selected-students-picker" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "collapse-tags": "",
                      placeholder:
                        "Tìm kiếm và tích chọn học sinh cần nhận xét...",
                    },
                    on: { change: _vm.onStudentSelectionChange },
                    model: {
                      value: _vm.selectedStudentIds,
                      callback: function ($$v) {
                        _vm.selectedStudentIds = $$v
                      },
                      expression: "selectedStudentIds",
                    },
                  },
                  _vm._l(_vm.allStudents, function (student) {
                    return _c("el-option", {
                      key: student.studentId,
                      attrs: {
                        label: student.studentName,
                        value: student.studentId,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.dataForm.students.length > 0
              ? _c(
                  "div",
                  { staticClass: "selected-students" },
                  _vm._l(_vm.dataForm.students, function (student) {
                    return _c(
                      "el-tag",
                      {
                        key: student.studentId,
                        staticClass: "selected-student-tag",
                        attrs: { closable: "", size: "small" },
                        on: {
                          close: function ($event) {
                            return _vm.removeStudent(student.studentId)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(student.studentName) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _c("div", { staticClass: "selected-students-empty" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(
                    " Chưa có học sinh nào được chọn. Vui lòng chọn học sinh ở ô trên!\n      "
                  ),
                ]),
          ]),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.period === "WEEKLY" ? "Tuần" : "Tháng",
                prop: "date",
              },
            },
            [
              _c("el-date-picker", {
                style: { width: _vm.period === "WEEKLY" ? "100%" : "200px" },
                attrs: {
                  type: _vm.period === "WEEKLY" ? "week" : "month",
                  "value-format":
                    _vm.period === "WEEKLY" ? "yyyy-MM-dd" : "yyyy-MM",
                  format:
                    _vm.period === "WEEKLY"
                      ? "Tuần WW (từ dd/MM/yyyy)"
                      : "MM/yyyy",
                  placeholder:
                    _vm.period === "WEEKLY" ? "Chọn tuần" : "Chọn tháng",
                  clearable: false,
                  disabled: "",
                },
                model: {
                  value: _vm.dataForm.date,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "date", $$v)
                  },
                  expression: "dataForm.date",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Nội dung", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 6,
                  placeholder: "Nhập nội dung nhận xét...",
                  maxlength: _vm.contentMaxlength,
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.dataForm.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "content", $$v)
                  },
                  expression: "dataForm.content",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "evl-upload-section" },
            [
              _c("div", { staticClass: "evl-upload-section__header" }, [
                _c("span", { staticClass: "evl-upload-title" }, [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _vm._v(" File & hình ảnh đính kèm\n        "),
                ]),
                _c("span", { staticClass: "evl-upload-subtitle" }, [
                  _vm._v(
                    "Tối đa 3 file/nhận xét (dùng chung cho các học sinh đã chọn)"
                  ),
                ]),
              ]),
              _c(
                "el-upload",
                {
                  staticClass: "evl-drag-uploader",
                  attrs: {
                    drag: "",
                    action: "#",
                    "auto-upload": false,
                    "file-list": _vm.fileList,
                    limit: 3,
                    accept: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
                    multiple: "",
                    "on-change": _vm.handleFileChange,
                    "on-remove": _vm.handleFileRemove,
                    "on-exceed": _vm.handleFileExceed,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("\n          Kéo thả file/ảnh vào đây hoặc "),
                    _c("em", [_vm._v("nhấn để chọn file")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }